import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=7a91c535&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=7a91c535&prod&lang=scss&scoped=true"
import style1 from "./Resources.vue?vue&type=style&index=1&id=7a91c535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a91c535",
  null
  
)

export default component.exports